export default __webpack_public_path__ + "static/media/icon-sign-out-1.c1e85565.svg";